import { render, staticRenderFns } from "./SecurityInfoCardSkeleton.vue?vue&type=template&id=5a4c4e3a&scoped=true"
import script from "./SecurityInfoCardSkeleton.vue?vue&type=script&lang=js"
export * from "./SecurityInfoCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./SecurityInfoCardSkeleton.vue?vue&type=style&index=0&id=5a4c4e3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4c4e3a",
  null
  
)

export default component.exports